export const appConstants = {
    INC_CALLSINFLIGHT: 'INC_CALLSINFLIGHT',
    DEC_CALLSINFLIGHT: 'DEC_CALLSINFLIGHT',
    CLEAR_CALLSINFLIGHT: 'CLEAR_CALLSINFLIGHT'
};
